import React, { useState } from 'react';
import close from '../../../../src/close.svg';
const Modal = ({ isOpen, onClose }) => {
  const modalClasses = isOpen
    ? 'fixed top-0 inset-0 left-0 w-full h-auto flex justify-center items-center bg-gray-800 bg-opacity-75 font-custom1 overflow-hidden overscroll-none'
    : 'hidden';

  return (
    <div className={modalClasses}>
      <div className="bg-white p-4  max-w-lg z-50">
        <div className="flex justify-between bg-main text-white rounded-md mb-4">
          <h3 className="text-2xl font-bold text-right mb-4 p-3">
            مسیر آذر شفیعی:
          </h3>
          <img
            src={close}
            alt="close"
            style={{ width: '60px', height: '60px' }}
            className="p-2 text-xs justify-left font-bold  cursor-pointer"
            onClick={onClose}></img>
        </div>
        <p className="text-sm text-justify xs:overflow-y-scroll h-1/4 z-50 hover:z-50">
          از نوجوانی با مسئله اضافه وزن درگیر بودم. سال ها با رژیم های تهاجمی
          وزن کم می کردم ولی دوباره بعد از یک مدت برمی گشتم به همان وزن قبلی و
          سر خونه ی اول. اون روزها من هم مثل خیلی از افراد کفش آهنی اراده می
          پوشیدم تا توی ماراتن رژیم گرفتم کم نیارم ولی انگار داشتم روی یه تردمیل
          می دوییدم... به جز خستگی خبری از رسیدن به مقصد نبود! دیگه حالم از کلمه
          رژیم بهم می خورد، از طرفی انقدر چاق شده بودم که هیچ کدوم از لباس هام
          اندازه ام نمی شد. کلافگی و افسردگیم به اونجایی رسید که سال ۹۸ تصمیم
          گرفتم برم عمل جراحی کنم و از شر چربی ها خلاص بشم. البته شانس آوردم که
          عمل کنسل شد،چرا؟ به خاطر کرونا! از اون روز تصمیم گرفتم سالم خوری کنم
          تا وقتی کرونا کم بشه و بتونم برم سمت اتاق عمل کنم. اما آذی اون موقع از
          کجا می دونست سالم خوری چی هست؟! هیچ ایده ای نداشتم که باید از کجا باید
          شروع کنم و چی کار کنم... یکسال بعد با کوچینگ تغذیه آشنا شدم، هرچه قدر
          بیشتر مطالعه کردم، بیشتر به این پی بردم که چقدر راه رو اشتباه رفتم و
          چقدر به بدن و ذهنم آسیب وارد کردم. با گذشت زمان و دیدن اینکه چطور اول
          بدنم و بعد تک تک ابعاد زندگیم دگرگون شدن، تصمیم گرفتم بصورت علمی و
          آکادمیک وارد این حوزه بشم. در دوره تخصصی PN1 موسسه precision nutrition
          شرکت کردم و بعد از گذروندن امتحانات، سرتیفیکیت گرفتم. دیگه برای اینکه
          بتونم این دریچه ی جدید رو به بقیه هم نشون بدم و کمک کنم به آگاهی برسن
          احساس آمادگی می کردم. بعد از چند ماه با دیدن تغییرات مثبت و نتیجه
          گرفتن کلاینت ها، یکی از اساسی ترین تصمیم های زندگیم رو گرفتم. با کار و
          ۱۵ سال سابقه مدیر بازرگانی در حوزه نفت و گاز خداحافظی کردم تا به شکل
          فول تایم در حوزه ی کوچینگ تغذیه مشغول بشم. همیشه در مسیر معتقد بودم و
          هستم که یک کوچ متخصص باید مداوم به ارتقای خودش بپردازه و در حال آپدیت
          کردن مطالبی باشه که به کلاینت ها ارائه میده باشه، به خاطر همین در دوره
          های مربیگری، فیتنس و سمینارهای تغذیه ای و ورزشی زیادی شرکت کردم و می
          کنم و در حال حاضر دانشجوی PN2 هستم.
        </p>
      </div>
    </div>
  );
};

export default Modal;
